import MegaMenu from './mega-menu'

export default MegaMenu
